// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";

const LOAD_HISTORY_DATA = 'app/history/LOAD_HISTORY_DATA';

function loadTableData(path, limit, offset, date_start, date_end, historyPaymentType="all") {
    return dispatch => {
        let dataJson = {
            limit,
            offset,
            date_start,
            date_end,
            type: historyPaymentType
        };

        apiServices(dataJson, "post", `/customer/history/${path === "payment" ? "payment-v2" : path}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            
            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: LOAD_HISTORY_DATA,
                    payload: {
                        items: result
                    }
                });

            }
        })
    }
}

export {
    LOAD_HISTORY_DATA,
    loadTableData
}